import React, { useState } from 'react';
import Grid from '@mui/material/Grid';
import './upload-earning.css';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
// import { useHistory } from 'react-router-dom';
import http from '../../services/http-service';
import axios from 'axios';
import config from '../../config';
import { ToastContainer, toast } from 'react-toastify';
import { ProgressBar } from "react-bootstrap";
import { getErrorResponse } from '../../utils';
import Backdrop from '@mui/material/Backdrop';
import { FileUploader } from "react-drag-drop-files";
import CircularProgress from '@mui/material/CircularProgress';
import { useRef } from 'react';
// import uploadFilesService from '../../services/upload-files.service';

export default function UploadEarning() {
    // const ref = useRef();
    const [file, setFile] = useState([]);
    const [open, setOpen] = useState(false);
    const fileTypes = ["CSV"];
    const inputRef = useRef(null);
    // const [progress, setProgress] = useState(0)
    const [fileelementect, setFileelement] = useState([])
    const [fileUploadArr, setFileUploadArr] = useState([0])
    const [showfileUploadDiv, setShowfileUploadDiv] = useState(true)
    // const history = useHistory();
    // const [fileInputRef, setFileInputRef] = useState()
    // const goToPage = () => {
    //     history.push('/add-employee')
    // }

    const handleClose = () => {
        setOpen(false);
    };
    const handleToggle = () => {
        setOpen(!open);
    };

    const downloadFormatFile = () => {
        handleToggle()
        http('admin/upload_employee_earning_csv_file/', 'GET')
            .then(res => {
                if (res.status) {
                    window.location.href = res.data.data
                }
                else {
                    toast.error(res.message, {
                        toastId: "toastId2"
                    })
                }
                handleClose()
            },
                err => {
                    handleClose()
                    console.log('err....', err)
                })
    }
    const uploadCSVOnServer = (fileObj, index) => () => {
        const formdata = new FormData();
        formdata.append("file", fileObj.files);
        formdata.append("user_id", JSON.parse(localStorage.getItem('loginUser')).id);
        handleToggle()
        axios.post(config.apiGateway.URL + config.apiGateway.VERSION + "admin/upload_employee_earning_csv_file/", formdata, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
            onUploadProgress: data => {
                file[index].progress = Math.round((100 * data.loaded) / data.total)
                setFileelement(file);
            },
        }).then(res => {

            if (res.data.status) {
                file[index].status = true;
                file[index].statusText = "Done"
                setFileelement(file => file.map(files => (files.name === fileObj.name ? fileObj : file)));
                toast.success(res.data.message, {
                    toastId: "toastId1"
                })
            } else {
                file[index].status = false;
                file[index].statusText = "Failed"
                setFileelement(file => file.map(files => (files.name === fileObj.name ? fileObj : file)));
                const error = getErrorResponse(res.data.message)
                toast.error(error, { toastId: "toastId3", allowHtml: true })
            }

            handleClose()
        },
            err => {
                handleClose()
                console.log('err....', err)
            })
    }

    const removeFile = (index) => (event) => {
        file.splice(index, 1)
        setFileelement(file => file.map(files => (files.name === event.name ? event : file)));
    }

    const handleChange = (event) => {
        const selectedFile = event[0]
        if (selectedFile) {
            file.push({ progress: 0, files: selectedFile, status: false, statusText: '' })
            setFileelement(file => file.map(files => (files.name === event.name ? event : file)));
            setShowfileUploadDiv(false)
            fileUploadArr.push(fileUploadArr.length + 0)
        }
    }
    return (
        <div className='mainAppDiv'>
            <ToastContainer />

            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={open}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <Grid item container xs={12} md={12} sm={12} lg={12} className='commonPageDivGrid'>
                <div className='notIcon'> !</div>
                <div className='employeeFileUp'>Earning file upload: you can view details of files uploaded to Wagefit, download previously uploaded files and upload new earning files</div>
            </Grid>

            <Grid container className='commonPageDivGrid commonPageDivGridMG'>
                <Grid item xs={12} md={6} sm={6} lg={6} className='empFileGrid'>
                    <Typography variant="subtitle2" gutterBottom component="div" className='empFileGridTypo'>
                        Earning Files
                    </Typography>
                    <Typography variant="caption" display="block" gutterBottom className='empFileGridUpload' onClick={downloadFormatFile}>
                        uploaded and new
                    </Typography>
                </Grid>
                <Grid item xs={12} md={6} sm={6} lg={6} className='CloseUploadGrid'>
                    {/* <Button onClick={goToPage} variant="outlined" className=' CloseUploadGridBtn1'>
                        Add Employee
                    </Button> */}
                    <Button variant="outlined" className='CloseUploadGridBtn' onClick={downloadFormatFile}>
                        Download Format
                    </Button>
                </Grid>
                <Grid container className='Selectfiles'>
                    <Grid item xs={12} md={4} sm={12} lg={4} className='SelectfilesGrid'>
                        <Typography variant="subtitle2" gutterBottom component="div" className='uploadTitle'>
                            Drop files here or click to upload
                        </Typography>
                        <Typography variant="caption" display="block" gutterBottom component="div" className='TypoOnliText'>
                            Only <span className='xlsxSpan'>csv</span> are allowed for upload
                        </Typography>
                        <Typography variant="subtitle2" gutterBottom component="div" className='uploadFilrMainDiv'>
                            <label htmlFor="btn-upload">
                                {
                                    fileUploadArr.map((element, index) => (

                                        index == fileUploadArr.length - 1 || showfileUploadDiv == true ? <div className='fileUploader' >
                                            <FileUploader label="Upload or drop a file"
                                                multiple={true} ref={inputRef}
                                                handleChange={handleChange}
                                                name="file_{index}"
                                                hoverTitle="Drop here"
                                                types={fileTypes}
                                                fileOrFiles={file}
                                            />
                                        </div> : ''
                                    ))}

                            </label>
                        </Typography>

                    </Grid>
                    <Grid item xs={12} md={8} sm={12} lg={8} className='gridTypoEight'>
                        <Typography variant="subtitle2" gutterBottom component="div">
                            Files ready for upload
                        </Typography>

                        <Grid container className='fileQueueheader'>
                            <Grid item xs={2} sm={4} md={4} lg={4}>
                                Name
                            </Grid>
                            <Grid item xs={2} sm={1} md={1} lg={1}>
                                Size
                            </Grid>
                            <Grid item xs={3} sm={2} md={2} lg={2}>
                                Progress
                            </Grid>
                            <Grid item xs={2} sm={1} md={1} lg={1}>
                                Status
                            </Grid>
                            <Grid item xs={3} sm={4} md={4} lg={4}>
                                Actions
                            </Grid>
                        </Grid>
                        {
                            file.map((element, index) => (

                                <Grid container className='fileQueueheaderBottom'>
                                    <Grid item xs={2} sm={4} md={4} lg={4} key={'file' + index} className='fileQueueheaderBottomEmp'>
                                        {element.files.name}
                                    </Grid>
                                    <Grid key={'size' + index} item xs={2} sm={1} md={1} lg={1} className='fileQueueheaderBottomEmp fileQueueheaderBottomSz'>
                                        {element.files.size}
                                    </Grid>
                                    <Grid key={'progress' + index} item xs={3} sm={2} md={2} lg={2} className='fileQueueheaderBottomEmp fileQueueheaderBottomPrg'>
                                        {file[index].progress && <ProgressBar now={file[index].progress} label={`${file[index].progress}%`} />}
                                    </Grid>
                                    <Grid key={'status' + index} item xs={2} sm={1} md={1} lg={1} className='fileQueueheaderBottomEmp'>
                                        {file[index].statusText}
                                    </Grid>
                                    {
                                        !file[index].status ? <Grid key={'buttonDive' + index} item xs={3} sm={4} md={4} lg={4} className='fileQueueheaderBottomEmp'>
                                            <Button className='BtnUpload' onClick={uploadCSVOnServer(element, index)}>Upload</Button>
                                            <Button className='BtnCancel' onClick={removeFile(index)}>Cancel</Button>
                                            <Button className='BtnRemove' onClick={removeFile(index)}>Remove</Button>
                                        </Grid> : ''}
                                </Grid>
                            ))}
                        {/* <Grid container className='queuePrg'>
                            <typography className='queuePrgTypography'>
                                Queue progress
                            </typography>

                            <Box width={1000} className='sliderBox'>
                                <Slider disabled aria-label="Disabled slider" valueLabelDisplay="auto" className='sliderBoxInner' />
                            </Box>
                        </Grid> */}
                    </Grid>
                </Grid>
            </Grid>
        </div>



    )

}